import { createAsyncThunk } from '@reduxjs/toolkit';

import { getErrorMessage } from '@/shared/utils/error';
import type { RootState } from '@/store';

import type {
  ListarPendenciasPublicacaoInput,
  PendenciasPublicacaoPagina,
} from '../../types/pendenciasPublicacaoTypes';
import { listarPendenciasPublicacaoService } from './services';

export const listarPendenciasPublicacao = createAsyncThunk<
  PendenciasPublicacaoPagina,
  ListarPendenciasPublicacaoInput,
  { state: RootState; rejectValue: string }
>(
  'arbitro/listarPendenciasPublicacao',
  async (input, { rejectWithValue }) => {
    try {
      return await listarPendenciasPublicacaoService(input);
    } catch (erro) {
      return rejectWithValue(getErrorMessage(erro));
    }
  },
  {
    condition: ({ id, page = 1 }, { getState }) => {
      if (page === 1) return true;
      const atual = getState().arbitro.pendenciasPublicacao;
      return (
        atual.processoId === id &&
        !atual.loading &&
        page === atual.pagination.page + 1 &&
        page <= atual.pagination.totalPages
      );
    },
  },
);
